(() => {
  const init = () => {
    const root = document.querySelector('.km-story');
    if (!root || root.dataset.kmReady) return;
    root.dataset.kmReady = 'true';
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('km-in-view');
          observer.unobserve(entry.target);
        });
      }, {threshold: .15});
      root.querySelectorAll('[data-km-reveal]').forEach(el => observer.observe(el));
    }
    const spec = root.querySelector('#ezSpecGrid');
    root.querySelector('#ezModelTabs')?.addEventListener('click', event => {
      if (!event.target.closest('.ez-model-tab') || motion.matches) return;
      spec.animate([{opacity:.35,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:340,easing:'ease-out'});
    });
    root.querySelectorAll('.ez-faq-q').forEach((button,index) => {
      const answer = button.parentElement.querySelector('.ez-faq-a');
      answer.id = 'km-faq-answer-' + index;
      button.setAttribute('aria-controls',answer.id);
      button.setAttribute('aria-expanded',button.parentElement.classList.contains('active') ? 'true' : 'false');
      button.addEventListener('click',() => requestAnimationFrame(() => button.setAttribute('aria-expanded',button.parentElement.classList.contains('active') ? 'true' : 'false')));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
